"use strict";

var dfxpnwhebwvtppxfcqnvtfazbndvhhnf = {} /* tools               */
var pctkxnbaevzdafnwnccdqdnqbxztptke = {} /* shopify_tools       */
var nnhnwqxqwxevbcwezdczwctxqkhqtnxh = {} /* navbar              */
var eqcandxxbakvhkpebvdcqkcfkndfdwfa = {} /* enclosure           */

anti_fouling_configurator_enclosure_eqcandxxbakvhkpebvdcqkcfkndfdwfa( -1 );
function anti_fouling_configurator_enclosure_eqcandxxbakvhkpebvdcqkcfkndfdwfa( 
	import_timeout )
{
	function is_false( x )
	{
		return tools_NOT( ...x );
	}

	function not( x )
	{
		return tools_NOT( ...x );
	}

	console.debug("Aloha ...")

	if( imports() === false) return;

	if( !window )
	{
		return;
	}
	else
	{
		const run_once = "cnqbbqncdtkhpnebqnvwxattxffbvqkn";
		if( window[run_once] )
		{
			return;
		}
		window[run_once] = { once:true }
	}

	/** @type { Developement_Helpers } */
	const develope = 
		(window.develope && (window.develope instanceof Developement_Helpers))
		? (window.develope) 
		: new Developement_Helpers()

	develope.hello();

	const afc_options = tpewhxnzzahecfanwhfaefzaqdcfnbxq.options

	const afc_strings = xxzpawvbpvwnwawbnazvkkpqvbhwadva.strings;
	
	afc_strings.instructions = tvfpxpczkhfkhevnktpqfdqtwacpabct.strings.instructions;

	const afc_values = wdtazcakwcbfttehntqqbpqpqnwqkbdb.values;

	// afc_values.products       = qfnatpdpnvkwzatnbhvbxcbvxhndnpvx.values.products
	// afc_values.other_products = qfnatpdpnvkwzatnbhvbxcbvxhndnpvx.values.other_products
	// afc_values.primers        = qfnatpdpnvkwzatnbhvbxcbvxhndnpvx.values.primers

	afc_values.rules          = xnkdwqtcebqffddkqccqwabwbdhkpxec.values.rules

	afc_values.instructions   = xtcdpncdnvhaeafveqkdfkevtndwnwat.values.instructions

	const afc_product_data = pdcakecawwzebtanaetbqaqdzckfbccz

	const afc_colours = qnpceqbazbnxptnvzecbvdkacwwqqvav

	product_configurator()
	function product_configurator()
	{
		const configurator_af = new Configurator_AF();

		const boat = configurator_af.get_boat();

		const recipe = configurator_af.get_recipe();

		const recipe_html =
		{
			container: null
			, label: null
			, intro: null
			, boat: {
				label: null
				, text: null
			}
			, recommendation: {
				label: null
			}
			, product: {
				container: null
				, label: null
				, image: null
				, text: null
				, usps: {
					container: null
					, label: null
					, text: null
					, list: null
				}
				, colours: {
					container: null
					, label: null
					, text: null
					, selected:	{
						container: null
						, colour: null
						, text: null
					}
					, list: null
				}
			}
			, alternatives:	{
				container: null
				,label: null
				, Standard: {
					container: null
					,label: null
					,text: null
				}
				, Premium: {
					container: null
					,label: null
					,text: null
				}
				, No_Biocide: {
					container: null
					,label: null
					,text: null
				}
				, No_Biocide_Premium: {
					container: null
					,label: null
					,text: null
				}
			}
			, steps: {
				container: null
				,label: null
			}
			, preparations: {
				container: null
				,label: null
			}
			, priming: {
				container: null
				,label: null
			}
			, application: {
				container: null
				,label: null
			}
			, order:
				{label:  null
				,text:   null
				,button: null
				,explanation: null
				,primer:
					{label:  null
					,text:   null
					,button: null
				}
				,both:
					{label:  null
					,text:   null
					,button: null
				}
			}
			, extro: {
				label: null
				,text: null
			}
		}

		recipe.html = recipe_html;

		data()
		function data()
		{
			load_data()

			function load_data()
			{
				load_0c_Colours()

				load_1a_product_kinds()
				load_1b_product_catgories()

				load_1c_product_data( afc_product_data.products )
				load_1c_product_data( afc_product_data.primer   )
				load_1c_product_data( afc_product_data.tie_coat )
				load_1d_product_data_old_antifoulings( afc_product_data.old_antifoulings )

				load_2a_questions( afc_values.questions )
				load_2b_answers(   afc_values.answers   )

				load_3a_steps()
				load_3b_instructions( afc_values.instructions )

				load_4_rules( afc_values.rules )

				develope.message( "Colours: "      , afc_colours )
				develope.message( "Colours: "      , Colour )
				develope.message( "Kinds: "        , Product_Kind    .all_in_order )
				develope.message( "Categories: "   , Product_Category.all_in_order )
				develope.message( "Products: "     , Product         .all_in_order )
				develope.message( "Questions: "    , Question        .all_in_order )
				develope.message( "Answers: "      , Answer          .all_in_order )
				develope.message( "Steps: "        , Step            .all_in_order )
				develope.message( "Instructions: " , Instruction     .all_in_order )
				develope.message( "Rules: "        , Rule            .all_in_order )
				develope.message( "Rules general:" , Rule.general_rules )

				develope.message( "Boat:   " , boat   )
				develope.message( "Recipe: " , recipe )

				develope.message( "AFC: " , configurator_af )

				develope.enable_console_debug();

				function load_0c_Colours()
				{
					for( const key in afc_colours )
					{
						const c = afc_colours[key];
						if( typeof(c)==="object" )
						{
							if( ("hex" in c) && ("label" in c) )
							{
								if( (typeof(c.hex)==="string")
									&& ( c.hex.length > 0 )
									&& ( typeof(c.label)==="string")
									&& ( c.label.length > 0 ) )
								{
									const hex = c.hex.substring(1)

									const nc = Colour.from_hex( 
										hex , 
										null , 
										c.label , 
										c.label )

									configurator_af.add_colour( nc )
								}

								else continue;
							}
						}
					}
				}

				function load_1a_product_kinds()
				{
					var a = new Product_Kind( "Antifouling"     )
					var p = new Product_Kind( "Primer"          )
					var t = new Product_Kind( "Tie_Coat" )
					var o = new Product_Kind( "Old_Antifouling" )

					configurator_af.add_product_kind( a )
					configurator_af.add_product_kind( p )
					configurator_af.add_product_kind( t )
					configurator_af.add_product_kind( o )
				}

				function load_1b_product_catgories()
				{
					const cs   = new Product_Category( "Standard"           )
					const cp   = new Product_Category( "Premium"            )
					const cnb  = new Product_Category( "No_Biocide"         )
					const cnbp = new Product_Category( "No_Biocide_Premium" )

					configurator_af.add_product_category( cs   )
					configurator_af.add_product_category( cp   )
					configurator_af.add_product_category( cnb  )
					configurator_af.add_product_category( cnbp )

					const option_create = { create_if_not_exists: true };

					const bbb = new Product_Category( "bbb" )
						bbb.include_category(["bxx","xbx","xxb"] , option_create )

					const bgb = new Product_Category( "bgb" )
						bgb.include_category(["bxx","xgx","xxb"] , option_create )

					const brb = new Product_Category( "brb" )
						brb.include_category(["bxx","xrx","xxb"] , option_create )

					const brg = new Product_Category( "brg" )
						brg.include_category(["bxx","xrx","xxg"] , option_create )

					const byb = new Product_Category( "byb" )
						byb.include_category(["bxx","xyx","xxb"] , option_create )

					const grg = new Product_Category( "grg" )
						grg.include_category(["gxx","xrx","xxg"] , option_create )

					const rrr = new Product_Category( "rrr" )
						rrr.include_category(["rxx","xrx","xxr"] , option_create )

					const yyy = new Product_Category( "yyy" )
						yyy.include_category(["yxx","xyx","xxy"] , option_create )
				}


				function load_1c_product_data( given )
				{
					// const wanted_category_ids =  {"Standard":1,"Premium":1,"No_Biocide":1,"No_Biocide_Premium":1}

					var count_added = 0

					var currency_symbol = ""
					if( afc_product_data.currency )
					{
						currency_symbol = afc_product_data.currency
					}

					if( Array.isArray( given) )
					{
						for( const source of given )
						{
							if( tools_object_has_keys( source
									, ["id" , "kind" , "order" , "label" , "text" , "image_urls" , "shopify"] )
								&& tools_object_has_keys( source["shopify"] , ["id","handle","url","variants"] )
								&& Array.isArray(source["shopify"]["variants"])
								&& source["shopify"]["variants"].length > 0 )
							{
								const product_colours = []
								const product_amounts = []
								const amounts_by_colour = {}

								const variants = []
								const shopify_data =
									{ "variants": variants
									,	"id":     source["shopify"].id
									,	"handle": source["shopify"].handle
									,	"url":    source["shopify"].url
									,	"usps":   []
								}
								if( source["shopify"]["USP_HTML"] )
								{
									shopify_data.usps.push( source["shopify"]["USP_HTML"] )
								}

								for( const v of source["shopify"]["variants"] )
								{
									if( tools_object_has_keys(v
										, ["id","order","options","price","price_string"] ) )
									{
										const variant =
											{	id:           v.id
											, order:        v.order
											, options:      v.options
											, price:        v.price
											, price_string: v.price_string
											, colour:       "_unknown_colour"
											, amount_ml:    -1
											, unit_price_info: null
										}
										if( tools_object_has_keys(v , ["qv","qu","rv","ru"] ) )
										{
											variant.unit_price_info =
												{ qv: v.qv
												, qu: v.qu
												, rv: v.rv
												, ru: v.ru
											}
										}

										var colour = "";
										var amount_ml = -1;

										for( const o of v.options )
										{
												const c = parse_colour(o)
												const a = parse_amount_ml(o)
												if( c in afc_colours ) {
													colour = c;
												}
												if( a > 0 )	{
													amount_ml = a;
												}
										}

										if( colour.length > 1 )  { variant.colour = colour }

										if( amount_ml > 0 )
										{
											variant.amount_ml = amount_ml
										}
										else
										{
											if(  (variant.unit_price_info != null )
												&& (variant.unit_price_info.qu == "ml" ) )
											{
													variant.amount_ml = variant.unit_price_info.qv
											}
											else {continue;}
										}

										variants.push( variant );

									}
									else {continue;}

									for( const variant of variants )
									{
										tools_array_push_if_not_included( product_amounts , variant.amount_ml )
										tools_array_push_if_not_included( product_colours , variant.colour )
										if( (variant.colour in amounts_by_colour) == false )
										{
											amounts_by_colour[variant.colour] = []
										}
										tools_array_push_if_not_included(
											amounts_by_colour[variant.colour]
											, variant.amount_ml )
									}
								}

								const kind = Product_Kind.get( source.kind )
								if( (kind != null) 	&& (product_amounts.length >= 1 ) )
								{
									const p = new Product( source.id , kind.id , source.label )
									p.coverage_sqm_per_l = get_product_coverage_sqm_per_l( source )
									// kind.product_ids.push( source.id )
									if( "category" in source )
									{
										const category = Product_Category.get( source["category"] )
										if( category != null )
										{
											p.add_to_category( category )
										}
									}

									p.order = source.order
									p.image_urls = tools_to_string_array( source["image_urls"] )
									p.texts = [ source["text"] ]
									// p.amounts = product_amounts
									// p.colours = product_colours
									// p.amounts_by_colour = amounts_by_colour
									p.data.shopify = shopify_data
									count_added += 1

									for( const variant of shopify_data.variants )
									{
										p.add_variant(
																variant.id
																, variant.id
																, variant.amount_ml
																, Colour.get_Colour( variant.colour )
																, variant.price
																, variant.price_string
																, currency_symbol
															)
									}

									configurator_af.add_product( p )
								}
								else { continue; }
							}
						}
					}

					return count_added;

					function get_product_coverage_sqm_per_l( source )
					{
						const fallback_coverage_sqm_per_l = 10.0

						for( const key of [ "coverage_sqm_per_l" , "coverage_m2_per_l" , "coverage" , "ergiebigkeit" ] )
						{
							if( key in source )
							{
								const coverage = parse_coverage_sqm_per_l( source[key] )
								if( coverage > 0 )
								{
									return coverage;
								}
							}
						}

						const coverage_by_product_id =
						{
							p31: 9.2,
							p33: 9.6,
							p34: 10.0,
							p37: 10.8,
							p21: 10.0,
							p23: 10.0,
							pBCE: 10.0,
							pri117: 10.0,
							pri015: 10.0,
							priTC: 10.0
						}

						if( source.id in coverage_by_product_id )
						{
							return coverage_by_product_id[source.id];
						}

						return fallback_coverage_sqm_per_l;
					}

					function parse_coverage_sqm_per_l( value )
					{
						if( typeof(value) === "number"
							&& Number.isFinite(value)
							&& value > 0 )
						{
							return value;
						}

						if( typeof(value) === "string" )
						{
							const normalized = value.replace(",", ".")
							const match = normalized.match(/[0-9]+(?:\.[0-9]+)?/)
							const number = ( match == null ) ? NaN : Number.parseFloat( match[0] )
							if( Number.isFinite(number) && number > 0 )
							{
								return number;
							}
						}

						return 0;
					}

					/**
					 * @param {string!} s
					 * @returns {string!}
					 * */
					function parse_colour( s )
					{
							if( typeof(s)==="string" && s.length > 0 )
							{
									s = s.trim()
									if( s in afc_colours )
									{
											return s;
									}
									s = s.toLowerCase()
									if( s in afc_colours )
									{
											return s;
									}
							}

							return "";
					}

					/**
					 * @param {string!} s
					 * @returns {number}
					 * */
					function parse_amount_ml( s )
					{
							const regex_l = /.*(l).*/g
							const regex_ml = /.*(ml|milliliter).*/g
							const regex_m_l = /.*(m l).*/g

							if( typeof(s)==="string" )
							{
									s = s.trim().toLowerCase()
							}
							else
							{
									return -2;
							}

							if( typeof(s)==="string" && s.length > 0 )
							{
									const number = tools_extract_number_from_string(s)
									if( number > 0 )
									{
											if( s.match(regex_ml) != null )
											{
													return number;
											}
											if( s.match(regex_m_l) != null )
											{
													return number;
											}
											if( s.match(regex_l) != null )
											{
													return number * 1000;
											}
											return -64;
									}
									return -8;
							}
							else return -4;
					}
				}

				function load_1d_product_data_old_antifoulings( given )
				{
					var count_added = 0

					if( typeof(given)==="string" )
					{
						const lines = given.split("\n")
						for( const line of lines )
						{
							const parts = line.split(":")

							if( parts.length === 3 )
							{
								const id       = parts[0].trim()
								const category = parts[1].trim()
								const label    = parts[2].trim()
								if(  (       id.length > 0 )
									&& ( category.length > 0 )
									&& (    label.length > 0 ) )
								{
									const p = new Product( id , "Old_Antifouling" , label )

									p.add_to_category( category , true )

									configurator_af.add_product( p )
								}
							}
						}
					}

					return count_added;
				}


				function load_2a_questions( given )
				{
					for( var i = 0;  i < given.length  ;  i += 1 )
					{
						const source = given[i]

						const q = new Question( source.id , Question.Types[source.type] )

						configurator_af.add_question( q );
					}
				}

				function load_2b_answers( given )
				{
					for( var i = 0;  i < given.length  ;  i += 1 )
					{
						const source = given[i]
						
						const a = new Answer( source.id , source.question_id )

						configurator_af.add_answer( a );
						
						if( source.selection )
						{
							if( Array.isArray( source.selection ) )
							{
								for( var iS = 0;  iS < source.selection.length; iS++ )
								{
									const s = source.selection[iS];
									a.selection_add( s.value , s.label_id )
									const label = afc_strings.answers[a.id].selection[s.label_id]
									a.selection.set_label( label )
									a.selection.select_index1(1);
								}
							}
							if( source.selection == "Old_Antifouling" )
							{
								a.selection_add( "x" )
									.set_label( afc_strings.answers.q1a3.label )
								const kind = Product_Kind.get( source.selection )
								for( var j = 0;  j < kind.product_ids.length  ;  j += 1 )
								{
									const product = Product.get( kind.product_ids[j] )
									if( product.category_ids.length > 0 )
									{
										a.selection_add( product.category_ids[0] ).set_label( product.label )
									}
								}
								a.selection.select_index1(1);
							}
						}
						if( "boat" in source )
						{
							switch( source.boat )
							{
								case "l":
									boat.data.answers.length = a
									break;
								case "w":
									boat.data.answers.width = a
									break;
								case "d":
									boat.data.answers.depth = a
									break;
							}
						}
					}
				}


				function load_3a_steps()
				{
					var s = new Step( "remove"      , "Entfernen"   )
					configurator_af.add_step( s );
					var s = new Step( "wash"        , "Waschen"     )
					configurator_af.add_step( s );
					var s = new Step( "grind"       , "Anschleifen" )
					configurator_af.add_step( s );
					var s = new Step( "prime"       , "Grundieren"  )
					configurator_af.add_step( s );
					var s = new Step( "apply"       , "Auftragen"   )
					configurator_af.add_step( s );
					var s = new Step( "s_infos"     , "Infos"       )
					configurator_af.add_step( s );
					var s = new Step( "s_dev"       , "Dev/Debug/Reste" )
					configurator_af.add_step( s );
				}


				function load_3b_instructions( given_instructions )
				{
					for( var iG = 0;  iG < given_instructions.length  ;  iG += 1 )
					{
						const source = given_instructions[iG]

						const id = source.id
						const text_ids = source.text_id
						const step = source.step

						var   value = 0;
						if( "value" in source )
						{
							value = source["value"]
						}
						if( "amount" in source )
						{
							value = source["amount"]
						}

						var instruction_product_id = ""
						if( "product_id" in source )
						{
							instruction_product_id = source["product_id"]
						}

						const i = new Instruction( id , text_ids , value , step , instruction_product_id )

						configurator_af.add_instruction( i )
					}
				}


				function load_4_rules( given_rules )
				{
					for( var i = 0;  i < given_rules.length  ;  i += 1 )
					{
						const source = given_rules[i]
						const product_ids = source.product_id
						var answer_ids  = ""

						if( "general" in source  &&  source.general == true )
						{
							answer_ids = Rule.General_Rule
						}

						if( "answer_id" in source )
						{
							answer_ids = source["answer_id"]
						}
						else
						if( "answer_ids" in source )
						{
							answer_ids = source["answer_ids"]
						}

						var action = source.action
						var selection = null
						if( "selection" in source )
						{
							selection = source["selection"]
						}
						var value = 0
						if( "value" in source )
						{
							value = source.value
						}
						var step_id = ""
						if( "step" in source )
						{
							step_id = source.step
						}
						var instruction_id = ""
						if( "instruction" in source )
						{
							instruction_id = source.instruction
						}
						else
						if( "instructions" in source )
						{
							instruction_id = source.instructions
						}
						var rule_ids = ""
						if( "rule_ids" in source )
						{
							rule_ids = source["rule_ids"]
						}

						if( action == "current_antifouling" )
						{
							action = Rule.Actions.instruction
						}

						const r = new Rule( 
							source.id ,
							answer_ids , 
							selection , 
							product_ids , 
							action , 
							value , 
							instruction_id , 
							step_id , 
							rule_ids)

						configurator_af.add_rule( r )
					}
				}


				function sort_and_order_by_id( array_of_objects )
				{
					const a = array_of_objects

					function compare(a, b)
					{
						if (a.order && a.id && b.order && b.id)
						{
							var x = a.id
							var y = b.id

							if (x > y) { return 1 }
							if (x == y) { return 0 }
						}
						return -1;
					}

					a.sort(compare)

					for (var i = 0; i < a.length; i++)
					{
						const element = a[ i ];
						element.order = 1 + i
					}
				}


				/** @param {Array} array_of_objects  */
				function sort_by_order( array_of_objects )
				{
					const a = array_of_objects

					a.sort(compare)

					function compare(a, b)
					{
						if( a.order && b.order )
						{
							const x = a.order
							const y = b.order

							if( x >  y ){ return  1; }
							if( x == y ){ return  0; }
							if( x <  y ){ return -1; }
						}
						return 1;
					}
				}

			}
		}

		// const calculator = new Recipe_Calculator( recipe );
		const calculator = configurator_af.get_calculator();
		const calculated = [];
		function calculate( colour = null )
		{
			calculated.length = 0;

			apply_boat_type_selection( boat.html.input.factor )
			if( validate_boat_measurement_inputs() == false )
			{
				return calculated;
			}

			const unanswered_question = configurator_af.get_first_unanswered_question();

			if( null == unanswered_question )
			{
				calculator.calculate( colour )

				if( calculator.is_calculated() )
				{
					calculated.push(1)

					console.debug( "Recipe: " , recipe.selected_category )
				}
				else
				{

				}
			}
			else
			{
				console.debug( 
					"Not all questions have been answered: " 
					+ unanswered_question.order )
			}

			return calculated;

			function calculated_event()
			{

			}
		}

		function apply_boat_type_selection( selection_element )
		{
			if( selection_element instanceof HTMLSelectElement
				&& selection_element.selectedIndex >= 0 )
			{
				const option = selection_element.options[ selection_element.selectedIndex ]
				const index1 = selection_element.selectedIndex + 1
				const answer = Answer.get( selection_element.dataset.answer_id || "q6a4" )
				if( option != null
					&& answer instanceof Answer
					&& answer.selection.select_index1(index1) )
				{
					const factor = answer.selection.get_value(index1)
					if( typeof(factor) !== "number"
						|| Number.isFinite(factor) === false
						|| factor <= 0 )
					{
						return false;
					}

					boat.factor = factor
					boat.type = option.textContent
					develope.message( "boat.factor = " + boat.factor )
					console.debug( "Boat type: " + boat.type + " (" + boat.factor + ")" );
					return true;
				}
			}

			return false;
		}

		function validate_boat_measurement_inputs()
		{
			sync_boat_measurements_from_inputs()

			var valid = true
			for( const input_element of [
				boat.html.input.length,
				boat.html.input.width,
				boat.html.input.depth
			] )
			{
				if( mark_measurement_input_validity( input_element ) == false )
				{
					valid = false
				}
			}

			return valid && boat.has_valid_measurements()
		}

		function mark_measurement_input_validity( input_element )
		{
			const valid = is_measurement_input_valid( input_element )
			if( input_element != null && input_element.classList )
			{
				input_element.classList.toggle( "invalid" , valid == false )
				input_element.setAttribute( "aria-invalid" , valid ? "false" : "true" )
			}
			return valid
		}

		function sync_boat_measurements_from_inputs()
		{
			for( const input_element of [
				boat.html.input.length,
				boat.html.input.width,
				boat.html.input.depth
			] )
			{
				if( input_element != null
					&& input_element.dataset
					&& input_element.dataset.measurement_id
					&& input_element.value != null
					&& input_element.value.trim().length > 0
					&& is_measurement_input_valid( input_element ) )
				{
					const measurement = Measurement.get( input_element.dataset.measurement_id )
					if( measurement instanceof Measurement )
					{
						const parsed_value = parse_measurement_input_number( input_element.value )
						if( measurement.change_value( parsed_value , measurement.selected_unit ) )
						{
							switch (input_element.name)
							{
								case "width":
									boat.width_in_cm = measurement.value
									break;
								case "length":
									boat.length_in_cm = measurement.value
									break;
								case "depth":
									boat.depth_in_cm = measurement.value
									break;
							}
						}
					}
				}
			}
		}

		function is_measurement_input_valid( input_element )
		{
			if( input_element == null
				|| typeof(input_element.value) !== "string"
				|| input_element.value.trim().length < 1
				|| input_element.dataset == null
				|| input_element.dataset.measurement_id == null )
			{
				return false;
			}

			const measurement = Measurement.get( input_element.dataset.measurement_id )
			if( measurement instanceof Measurement )
			{
				const value = parse_measurement_input_number( input_element.value )
				const value_in_cm = tools_convert_value( value , measurement.selected_unit , "cm" )
				return ( typeof(value_in_cm) === "number"
					&& Number.isFinite(value_in_cm)
					&& value_in_cm > 0
					&& value_in_cm <= 10000 )
			}

			return false;
		}

		function parse_measurement_input_number( value )
		{
			if( typeof(value) === "number" )
			{
				return value;
			}

			if( typeof(value) === "string" )
			{
				const trimmed = value.trim().replace(/\s/g, "")

				if( /^[+-]?\d+([\.,]\d+)?$/.test(trimmed) )
				{
					return Number.parseFloat( trimmed.replace(",", ".") )
				}

				const localized_value = tools_number_parse_localized( value )
				if( Number.isFinite( localized_value ) )
				{
					return localized_value
				}
			}

			return NaN;
		}


		html_app()
		function html_app()
		{
			const html_afc_container = document.querySelector(".antifouling_configurator_01")
			var html_current_element_to_be_shown = null
			var html_startup_container = null
			var html_recipe_container  = null

			const html_ID_prefix = ""

			var html_navbar = Pages_Navigation( 8 , 1 , navigation_callback )
			if( afc_options.include_startpage === true )
			{
				html_navbar = Pages_Navigation( 9 , 1 , navigation_callback )
				var temp = html_navbar.pages
				html_navbar.pages = [ html_navbar.start_page , ...temp ]
				html_navbar.pages_by_number[html_navbar.start_page.number] = html_navbar.start_page
				html_navbar.pages_by_id[html_navbar.start_page.id] = html_navbar.start_page
				for( var i0P = 0 ;  i0P < html_navbar.pages.length ; i0P++ )
				{
					html_navbar.pages[i0P].index0 = i0P;
				}
			}

			create_html()

			if( afc_options.navbar_unlock_all_pages == true )
			{
				for( var i0P = 0 ;  i0P < html_navbar.pages.length ;  i0P++ )
				{
					html_navbar.pages[i0P].reachable = true;
				}
			}

			if( (afc_options.include_startpage == false)
				&& (afc_options.navbar_start_on_page > 0) )
			{
				for( var i0P = 0 ;  i0P <= afc_options.navbar_start_on_page ;  i0P++ )
				{
					if( i0P in html_navbar.pages_by_number )
					{
						html_navbar.pages_by_number[i0P].reachable = true;
					}
				}
				html_navbar.page( afc_options.navbar_start_on_page ).callback();
			}
			else
			{
				html_navbar.page( 0 ).callback();
			}

			if( afc_options.load_previous_session )
			{
				const code = String(Save_Slot.load_from_local_stroage())
				Save_Slot.set_from_code( boat , code )
				update_selected_answers()
			}


			function create_html()
			{
				if( html_afc_container == null ) return

				html_hide_element( html_afc_container )

				create_startup_area()

				create_questions()

				// add_options_for_question_1(answers_by_id[ "q1a4" ].html.container.querySelector(".text"))
				add_options_for_question_6()
				add_button_for_question_6( Question.get("q6").html.container )
				add_button_for_question_7( Question.get("q7").html.container )

				create_recipe_area()

				html_afc_container.style.paddingTop
					= afc_options.padding_top_value
						+ afc_options.padding_top_unit
				html_afc_container.style.paddingBottom
					= afc_options.padding_bottom_value
						+ afc_options.padding_bottom_unit

				html_show_element( html_afc_container )

				function create_startup_area()
				{
					const start_container = html_create_element( html_afc_container , "DIV" , "start" )
					html_hide_element( start_container )
					if( afc_options.nav_top === true )
					{
						html_navbar.create_html( start_container )
					}
					const start = html_create_element( start_container , "DIV" , "start_area" )
					if( afc_options.nav_bottom === true )
					{
						html_navbar.create_html( start_container )
					}

					const label = html_create_element( start , "DIV" , "label" )
					label.innerHTML = afc_strings.start.label
					const intro = html_create_element( start , "DIV" , "text" )
					intro.innerHTML = afc_strings.start.intro
					const text1 = html_create_element( start , "DIV" , "text" )
					text1.innerHTML = afc_strings.start.text1
					const text2 = html_create_element( start , "DIV" , "text" )
					text2.innerHTML = afc_strings.start.text2
					const text3 = html_create_element( start , "DIV" , "text" )
					text3.innerHTML = afc_strings.start.text3
					const text4 = html_create_element( start , "DIV" , "text" )
					text4.innerHTML = afc_strings.start.text4
					const text5 = html_create_element( start , "DIV" , "text" )
					text5.innerHTML = afc_strings.start.text5

					const begin  = html_create_element( start , "BUTTON" , "button_begin" )
					begin.innerHTML = afc_strings.start.begin
					begin.addEventListener( "click" , html_event_start_begin_button )

					const resume = html_create_element( start , "BUTTON" , "button_resume" )
					resume.innerHTML = afc_strings.start.resume
					resume.addEventListener( "click" , html_event_start_resume_button )

					const extro = html_create_element( start , "DIV" , "text" )
					extro.innerHTML = afc_strings.start.extro

					html_startup_container = start_container
				}

				function create_questions()
				{
					html_afc_container.classList.add("questions")

					for (var i0Q = 0; i0Q < Question.all_in_order.length; i0Q += 1)
					{
						/** @type {Question} */
						const q = Question.all_in_order[i0Q]
						q.data.page = i0Q + 1;

						const last_question = (i0Q===(Question.all_in_order.length - 1)) ? true : false

						const e = document.createElement("div")
						q.html.container = e
						e.id = q.id
						e.classList.add("question_" + q.id)
						e.classList.add("question")
						if (i0Q === 0)
						{
							html_current_element_to_be_shown = e
						}
						else
						{
							html_hide_element( e )
						}
						// e.id = ID_prefix + q.id
						e.innerHTML = "<div class=\"number\">" + afc_strings.questions[q.id].number + "</div>"
							+ "<div class=\"label\">" + afc_strings.questions[q.id].label + "</div>"
							+ "<div class=\"text\">" +  afc_strings.questions[q.id].text + "</div>"

						const as = document.createElement("div")
						as.classList.add("answers")

						create_answers( q , as )

						e.appendChild(as)

						// const bp = document.createElement("button")
						// bp.addEventListener( "click" , html_event_previous_question )
						// bp.innerHTML = strings.questions.go_to_previous
						// e.insertBefore( bp , e.firstChild )
						if( afc_options.nav_top === true )
						{
							e.insertBefore(html_navbar.create_html(), e.firstChild)
						}

						// const bn = document.createElement("button")
						// bn.addEventListener( "click" , html_event_next_question )
						// bn.innerHTML = strings.questions.go_to_next
						// e.appendChild( bn )
						if( afc_options.nav_bottom === true )
						{
							e.appendChild(html_navbar.create_html())
						}

						html_afc_container.appendChild(e)

						function create_answers( question , container )
						{
							/** @type {Question} */
							const q = question
							for( var i0possibleAID = 0 ;  i0possibleAID < q._possible_answer_ids.length ;  i0possibleAID += 1 )
							{
								const answer = Answer.get( q._possible_answer_ids[ i0possibleAID ] )

								if( !(answer instanceof Answer) )
								{
									continue;
								}

								answer.data.page = q.data.page
								const html_container = document.createElement("div")
								html_container.id = answer.id
								html_container.classList.add("answer")
								html_container.classList.add("answer_" + answer.id)
								answer.html.container = html_container

								const icon_container = html_create_element( null , "DIV" , "icon" )
								const icon = html_create_element( icon_container , "img" )
								icon.src = afc_strings.image_urls[answer.id][0]
								answer.html.icon = icon
								html_container.appendChild(icon_container)

								const label_element = document.createElement("div")
								label_element.classList.add("label")
								if( afc_strings.answers[answer.id].number )
								{
									label_element.innerHTML = "" + (afc_strings.answers[answer.id].number) + ": " + afc_strings.answers[answer.id].label
								}
								else
								{
									label_element.innerHTML = "" + afc_strings.answers[answer.id].label
								}
								answer.html.label = label_element
								html_container.appendChild( label_element )

								const text_element = document.createElement("div")
								text_element.classList.add("text")
								text_element.innerHTML = afc_strings.answers[answer.id].text
								answer.html.text = text_element
								html_container.appendChild(text_element)

								const selection_element = document.createElement("div")
								selection_element.classList.add("answer_selection")
								answer.html.selection = selection_element
								html_container.appendChild( selection_element )
								if( answer.has_selection )
								{
									add_options_to_answer( answer , selection_element )
								}

								if(	(q.type === Question.Types.checkbox)
									|| (q.type === Question.Types.radio) )
								{
									const button_element = document.createElement("button")
									button_element.classList.add("button")
									answer.html.button = button_element
									button_element.id = html_ID_prefix + answer.id
									button_element.value = ""
									if( answer.question.has_given_answer( answer ) )
									{
										button_element.value = "selected"
									}
									button_element.dataset.answer_id = answer.id
									button_element.addEventListener( "click" , html_event_pick_answer )

									button_element.innerHTML = afc_strings.select
									html_container.appendChild( button_element )
								}

								container.appendChild( html_container )


								/**
								 * @param {Answer} answer
								 * @param {HTMLElement} container
								 * */
								function add_options_to_answer( answer , container )
								{
									const selection = document.createElement("select")
									selection.dataset.answer_id = answer.id
									for( var i = 1 ;  i <= answer.selection.amount ;  i++ )
									{
										const label = answer.selection.get_label(i)
										const option = document.createElement("option")
										option.text = label
										option.value = i
										if( answer.selection.selected_index1 === i )
										{
											option.selected = true
										}
										selection.add(option)
									}
									selection.addEventListener("change", html_event_answer_sub_selection_selected)
									answer.html.selection = selection
									container.appendChild(selection)
								}


								/** @param {Answer} answer  */
								/** @param {HTMLElement} container  */
								function add_measurement_to_answer( answer , container )
								{
									const selection = document.createElement("select")
									for( var i = 0 ;  i < answer.selection.amount ;  i++ )
									{
										const label = answer.selection.options.labels[i]
										const option = document.createElement("option")
										option.text = label
										option.value = i+1
										selection.add(option)
										if( i === 0 )
										{
											boat.other_product_id = answer.selection.options.values[i]
										}
									}
									selection.addEventListener("change", html_event_answer_sub_selection_selected)
									container.appendChild(selection)
								}
							}
						}
					}
				}


				function add_options_for_question_6()
				{
					const type_answer = Answer.get( "q6a4" )
					if( type_answer == null )
					{
						return;
					}
					type_answer.data.boat_value = "factor"
					const selection = type_answer.html.selection
					// boat.type = option.text
					// boat.factor = type_answer.selection.options.values[i]
					selection.addEventListener("change", html_event_boat_type_selection)
					boat.html.input.factor = selection
					apply_boat_type_selection( selection )

					boat.html.input.length = add_measurement( "q6a1" , boat.length_in_cm , "length" ).value_element
					boat.html.input.width  = add_measurement( "q6a2" , boat .width_in_cm , "width"  ).value_element
					boat.html.input.depth  = add_measurement( "q6a3" , boat .depth_in_cm , "depth"  ).value_element

					function add_measurement( answer_id , value , name )
					{
						const answer = Answer.get( answer_id )
						answer.data.boat_value = name

						const measurement = answer.measurement
						const pre_selected_unit = afc_strings.units.default
						measurement.change_unit("cm")
						measurement.change_value( value )
						measurement.change_unit( pre_selected_unit )

						const container = document.createElement("div")
						container.className = "value_with_unit"

						const unit_element = document.createElement("select")
						unit_element.className = "value_unit_selector"

						var units = [ "cm" , "m" , "mm" ]
						add_units_as_group_to_selection( unit_element , afc_strings.units.metric , units , measurement )

						var units = [ "f" ,  "in" ]
						add_units_as_group_to_selection( unit_element , afc_strings.units.imperial , units , measurement )

						unit_element.value = pre_selected_unit
						if( unit_element.value != pre_selected_unit )
						{
							unit_element.selectedIndex = 0;
						}

						var label_element = document.createElement("label")

						const value_element = document.createElement("input")
						value_element.className = "value_input"
						value_element.type = "text"
						value_element.inputMode = "decimal"
						value_element.autocomplete = "off"
						value_element.required = true
						value_element.name = name
						value_element.value = measurement.converted_value

						const value_unit_element = document.createElement("DIV")
						value_unit_element.className = "value_unit"
						value_unit_element.innerHTML = afc_strings.units.short[measurement.selected_unit]

						container    .dataset.measurement_id = answer.measurement.id
						value_element.dataset.measurement_id = answer.measurement.id
						unit_element .dataset.measurement_id = answer.measurement.id

						// l.addEventListener("change", html_event_boat_measurements_change)
						// l.addEventListener("input", html_event_boat_measurements_change)

						value_element.addEventListener( "blur"   , html_event_measurement_value_blur   )
						value_element.addEventListener( "input"  , html_event_measurement_value_change )
						value_element.addEventListener( "change" , html_event_measurement_value_change )
						unit_element .addEventListener( "change" , html_event_measurement_unit_change  )

						measurement.html.container = container
						measurement.html.value     = value_element
						measurement.html.unit      = value_unit_element
						measurement.html.unit_selector = unit_element

						label_element.appendChild(value_element)
						label_element.appendChild(value_unit_element)
						container.appendChild(label_element)
						var label_element = document.createElement("label")
						label_element.appendChild(unit_element)
						container.appendChild(label_element)

						//html_insert_after( answer.html.selection , container )
						answer.html.selection.replaceWith( container )

						return { answer , measurement , container , value_element , unit_element };


						function add_units_as_group_to_selection( select_element , label , units , measurement )
						{
							var selected_index = -1
							const optgroup = document.createElement('optgroup');
							optgroup.label = label
							for( var i = 0 ;  i < units.length ;  i++ )
							{
								const unit = units[i]
								if( unit === "-" )
								{
									const opt = document.createElement('option');
									opt.value = unit;
									opt.innerHTML = "-------";
									opt.disabled = true
									optgroup.appendChild(opt);
								}
								else if( measurement.units.indexOf(unit) > 0 )
								{
									const opt = document.createElement('option');
									opt.value = unit;
									opt.innerHTML = afc_strings.units.short[unit] + ": " + afc_strings.units.long[unit];
									optgroup.appendChild(opt);
								}
								if( unit === measurement.selected_unit )
								{
									selected_index = i
								}
							}
							select_element.add(optgroup)
							if( selected_index >= 0 )
							{
								selected_index = i
								select_element.selectedIndex = select_element.length - units.length + selected_index
							}
						}
					}

				}

				function add_button_for_question_6(element)
				{
					const bn = document.createElement("button")
					bn.classList.add( "external_button" )
					bn.addEventListener("click", html_event_boat_next_question )
					bn.innerHTML = afc_strings.questions.go_to_next
					const answers = element.querySelector(".answers")
					if( answers != null )
					{
						const before = answers.nextSibling
						element.insertBefore( bn , before )
					}
				}

				function add_button_for_question_7(element)
				{
					const bn = document.createElement("button")
					bn.classList.add( "external_button" )
					bn.addEventListener("click", html_event_calculate)
					bn.innerHTML = afc_strings.calculate
					const answers = element.querySelector(".answers")
					if( answers != null )
					{
						const before = answers.nextSibling
						element.insertBefore( bn , before )
					}
				}

				function create_recipe_area()
				{
					const recipe_container = html_create_element(html_afc_container, "section", "recipe")
					html_hide_element( recipe_container )
					recipe.html.container = recipe_container

					// html_navbar.create_html( recipe_container )

					var part = html_create_element(recipe_container, "div", "parts part2")

					var label = html_create_element(part, "h2", "label")
					label.innerHTML = afc_strings.recipe.label
					recipe.html.label = label

					const intro = html_create_element(part, "p", "intro")
					html_hide_element( intro )

					intro.innerHTML = afc_strings.recipe.intro
					recipe.html.intro = intro

					const boat = html_create_element(part, "section", "boat")
					html_hide_element( boat )
					recipe.html.boat.label = html_create_element(boat, "H3", "label")
					recipe.html.boat.label.innerHTML = afc_strings.boat.label
					// recipe.html.boat.text = create_html_element(boat, "p", "text")

					const recommendation = html_create_element(part, "section", "recommendation")
					label = html_create_element(recommendation, "H3", "label")
					label.innerHTML = afc_strings.recipe.recommendation.label
					recipe.html.recommendation.label = label

					const recommendation_product = html_create_element(recommendation, "section", "product")
					label = html_create_element(recommendation_product, "H4", "label")
					label.innerHTML = afc_strings.recipe.product.label
					recipe.html.product.label = label

					var image = html_create_element(recommendation_product, "img")
					image.alt = ""
					html_hide_element( image )
					recipe.html.product.image = image
					recipe.html.product.text = html_create_element(recommendation_product, "p", "text")

					create_usp_area();

					// create_colour_selection();
					create_colour_selection_2();

					const alternatives = html_create_element(recommendation, "section", "alternatives")
					recipe.html.alternatives.container = alternatives
					label = html_create_element( alternatives, "H4", "label" )
					label.innerHTML = afc_strings.recipe.alternatives.label
					recipe.html.alternatives.label = label

					var container = html_create_element(alternatives, "div", "alternative alternative_standard")
					recipe.html.alternatives.Standard.container = container
					label = html_create_element( container , "span" , "label" )
					label.innerHTML = afc_strings.recipe.alternatives.standard
					recipe.html.alternatives.Standard.label = label
					var text = html_create_element( container , "BUTTON" , "text")
					text.dataset.a1 = 0
					text.dataset.a2 = "Standard"
					text.addEventListener( "click" , html_event_alternative_product )
					recipe.html.alternatives.Standard.text = text

					var container = html_create_element(alternatives, "div", "alternative alternative_premium")
					recipe.html.alternatives.Premium.container = container
					label = html_create_element( container , "span" , "label" )
					label.innerHTML = afc_strings.recipe.alternatives.premium
					recipe.html.alternatives.Premium.label = label
					var text = html_create_element( container , "BUTTON" , "text")
					text.dataset.a1 = 0
					text.dataset.a2 = "Premium"
					text.addEventListener( "click" , html_event_alternative_product )
					recipe.html.alternatives.Premium.text = text

					var container = html_create_element(alternatives, "div", "alternative alternative_no_biocide")
					recipe.html.alternatives.No_Biocide.container = container
					label = html_create_element( container , "span" , "label" )
					label.innerHTML = afc_strings.recipe.alternatives.no_biocide
					recipe.html.alternatives.No_Biocide.label = label
					var text = html_create_element( container , "BUTTON" , "text")
					text.dataset.a1 = 0
					text.dataset.a2 = "No_Biocide"
					text.addEventListener( "click" , html_event_alternative_product )
					recipe.html.alternatives.No_Biocide.text = text

					var container = html_create_element(alternatives, "div", "alternative alternative_no_biocide_premium")
					recipe.html.alternatives.No_Biocide_Premium.container = container
					label = html_create_element( container , "span" , "label" )
					label.innerHTML = afc_strings.recipe.alternatives.no_biocide_premium
					recipe.html.alternatives.No_Biocide_Premium.label = label
					var text = html_create_element( container , "BUTTON" , "text")
					text.dataset.a1 = 0
					text.dataset.a2 = "No_Biocide_Premium"
					text.addEventListener( "click" , html_event_alternative_product )
					recipe.html.alternatives.No_Biocide_Premium.text = text

					var part = html_create_element( recipe_container , "div" , "parts part4" )

					const steps_container = html_create_element( part , "section" , "steps")
					recipe.html.steps.container = steps_container
					var label = html_create_element( steps_container , "H3" , "label"  )
					label.innerHTML = afc_strings.recipe.steps.label
					recipe.html.steps.label = steps_container

					const step_list = [	"remove" , "wash"   , "grind"  , "prime"  , "apply" ]
					for( const step_id of step_list )
					{
						const step = Step.get( step_id )
						if( step != null )
						{
							const container = html_create_element( steps_container, "section", "step")
							container.classList.add( "step_id_" + step.id )
							step.html.container = container
							const label = html_create_element(container,"H4","label")
							step.html.label = label
							const intro = html_create_element(container,"P","intro text")
							step.html.intro = intro
							const content = html_create_element(container,"DIV","content")
							step.html.content = content
							const extro = html_create_element(container,"P","extro text")
							step.html.extro = extro
							if( step.id in afc_strings.steps )
							{
								const step_strings = afc_strings.steps[step.id]
								if( "label" in step_strings
									&& step_strings["label"].length > 0 )
								{
									label.innerHTML = step_strings.label;
								}
								else
								{
									html_hide_element( label )
								}
								if( "intro" in step_strings
									&& step_strings["intro"].length > 0 )
								{
									intro.innerHTML = step_strings.intro;
								}
								else
								{
									html_hide_element( intro )
								}
								if( "extro" in step_strings
									&& step_strings["extro"].length > 0 )
								{
									extro.innerHTML = step_strings.extro;
								}
								else
								{
									html_hide_element( extro )
								}
							}
						}
					}

					const extro = html_create_element(steps_container, "section", "extro")
					html_hide_element( extro )
					recipe.html.extro.label = html_create_element(extro, "H4", "label")
					recipe.html.extro.label.innerHTML = afc_strings.recipe.extro.label
					recipe.html.extro.text = html_create_element(extro, "p", "text")
					recipe.html.extro.text.innerHTML = afc_strings.recipe.extro.text

					create_order_area()

					// html_navbar.create_html( recipe_container )

					html_recipe_container = recipe_container


					function create_usp_area()
					{
						recipe.html.product.usps.container = html_create_element(recommendation_product, "DIV", "details usps");

						const label = html_create_element(recipe.html.product.usps.container, "H5", "label");
						const list = html_create_element(recipe.html.product.usps.container, "UL", "list");
						const text = html_create_element(recipe.html.product.usps.container, "DIV", "text");

						label.innerHTML = afc_strings.recipe.product.unique_selling_points.label;

						html_hide_element( list )

						text.innerHTML = "";

						recipe.html.product.usps.label = label;
						recipe.html.product.usps.list = list;
						recipe.html.product.usps.text = text;
					}

					function create_colour_selection()
					{
						const container = html_create_element(recommendation_product, "DIV", "colours colour_selection");

						const label = html_create_element( container , "H5"  , "label" );
						const text  = html_create_element( container , "DIV" , "text"  );
						const s_text   = html_create_element(  container , "DIV" , "colour colour_selected" );
						const s_colour = s_text;
						const selected = s_text;
						const list  = html_create_element( container , "UL"  , "list"  );

						label.innerHTML = afc_strings.recipe.product.colour_selection.label;
						text.innerHTML = afc_strings.recipe.product.colour_selection.text;

						list.addEventListener( "click" , html_event_colour_select )

						recipe.html.product.colours.container = container;
						recipe.html.product.colours.label = label;
						recipe.html.product.colours.text  = text;
						recipe.html.product.colours.selected.container = selected
						recipe.html.product.colours.selected.colour    = s_colour
						recipe.html.product.colours.selected.text      = s_text
						recipe.html.product.colours.list = list;
					}

					function create_colour_selection_2()
					{
						const container = html_create_element(recommendation_product, "DIV", "colours colour_selection");

						const label = html_create_element( container , "H5"  , "label" );
						const text  = html_create_element( container , "DIV" , "text"  );
						const list  = html_create_element( container , "DIV"  , "colour_product_list"  );

						list.addEventListener( "click" , html_event_colour_select )

						label.innerHTML = afc_strings.recipe.product.colour_selection.label;
						text.innerHTML = afc_strings.recipe.product.colour_selection.text;

						recipe.html.colours2 = {};
						recipe.html.colours2.container = container;
						recipe.html.colours2.label = label;
						recipe.html.colours2.text  = text;
						recipe.html.colours2.list = list;
					}

					function create_order_area()
					{
						const container = html_create_element(steps_container, "DIV", "order_area")
						recipe.html.order.container  = container

						var label  = html_create_element( container , "H5" , "order label" )
						label.innerHTML = afc_strings.recipe.order.label
						recipe.html.order.label  = label

						// var div    = html_create_element( container , "DIV" , "order order_rporduct div"   )
						// var text   = html_create_element( div    , "DIV"    , "order order_rporduct text"  )
						// var button = html_create_element( div    , "BUTTON" , "order order_rporduct" )
						// text  .innerHTML = afc_strings.recipe.order.text
						// button.innerHTML = afc_strings.recipe.order.button
						// button.addEventListener( "click" , html_event_order_product_button )
						// recipe.html.order.text   = text
						// recipe.html.order.button = button

						// var div    = html_create_element( container , "DIV" , "order order_primer div"   )
						// var text   = html_create_element( div    , "DIV"    , "order order_primer text"  )
						// var button = html_create_element( div    , "BUTTON" , "order order_primer" )
						// text  .innerHTML = afc_strings.recipe.order.primer.text
						// button.innerHTML = afc_strings.recipe.order.primer.button
						// button.addEventListener( "click" , html_event_order_primer_button )
						// recipe.html.order.primer.text   = text
						// recipe.html.order.primer.button = button

						// var div    = html_create_element( container , "DIV" , "order order_both div"   )
						// var text   = html_create_element( div    , "DIV"    , "order order_both text"  )
						// var button = html_create_element( div    , "BUTTON" , "order order_both" )
						// text  .innerHTML = afc_strings.recipe.order.both.text
						// button.innerHTML = afc_strings.recipe.order.both.button
						// button.addEventListener( "click" , html_event_order_both_button )
						// recipe.html.order.both.text   = text
						// recipe.html.order.both.button = button

						const explanation = html_create_element( container , "DIV" , "order_explanation text" )
						recipe.html.order.explanation = explanation

						const table_area = html_create_element( container , "DIV" , "order_tables" )
						recipe.html.order.table_area = table_area
					}
				}
			}


			function html_change_to_question( i1question )
			{
			}


			function html_event_boat_next_question(x)
			{
				apply_boat_type_selection( boat.html.input.factor )

				if( validate_boat_measurement_inputs() )
				{
					html_navbar.answer().callback()
				}
				else
				{
					const message = afc_strings.questions.invalid_measurements
						|| afc_strings.questions.need_to_asnwer_all
					window.alert( message )
				}
			}

			function html_event_next_question(x)
			{
				html_navbar.page_next()
				html_navbar.callback()
			}

			function html_event_previous_question(x)
			{
				html_navbar.page_previous()
				html_navbar.callback()
			}

			function html_event_calculate(x)
			{
				calculate()
				if( calculated.length > 0 )
				{
					html_navbar.answer()
					const page = html_navbar.pages_by_id["R"]
					page.reachable = true
					html_navbar.page( page.number ).callback();

					update_recipe_html();
				}
				else
				{
					const unanswered_question = configurator_af.get_first_unanswered_question()
					const message = ( unanswered_question instanceof Question )
						? afc_strings.questions.need_to_asnwer_all
						: afc_strings.questions.invalid_measurements
					window.alert( message )
				}
			}

			function html_event_answer_sub_selection_selected(x)
			{
				if( x.srcElement.selectedOptions )
				{
					const selection_element = x.srcElement
					const selected = selection_element.selectedOptions
					if( selected.length === 1 )
					{
						const option = selected[0]
						const answer = Answer.get( selection_element.dataset.answer_id )
						const value = Number.parseInt( option.value )
						if( value > 0  )
						if( value <= answer.selection.amount )
						{
							answer.selection.select_index1(value)

							if( answer.id == "q1a4" )
							{
								develope.message( "q1a4 selection value: " , answer.selection.get_value() )
							}
						}
					}
				}
			}

			function html_event_boat_type_selection(x)
			{
				const selection_element = x.currentTarget || x.srcElement
				apply_boat_type_selection( selection_element )
			}

			function html_event_measurement_value_change(x)
			{
				if(x.srcElement.dataset && x.srcElement.dataset.measurement_id)
				{
					const valid = mark_measurement_input_validity( x.srcElement )
					if( valid == false )
					{
						boat.invalidate_measurement( x.srcElement.name )
						return;
					}
					if( x.srcElement.value == null || x.srcElement.value.trim().length < 1 )
					{
						return;
					}
					const value = x.srcElement.value
					const measurement = Measurement.get( x.srcElement.dataset.measurement_id )
					if( measurement instanceof Measurement )
					{
						const parsed_value = parse_measurement_input_number( value )
						const changed = measurement.change_value( parsed_value , measurement.selected_unit )
						if( changed )
						{
//						measurement.html.value.value = tools_number_format_localized( measurement.converted_value )
							switch (x.srcElement.name)
							{
								case "width":
									boat.width_in_cm = measurement.value
									break;
								case "length":
									boat.length_in_cm = measurement.value
									break;
								case "depth":
									boat.depth_in_cm = measurement.value
									break;
							}
						}
					}
				}
			}

			function html_event_measurement_value_blur(x)
			{
				if(x.srcElement.value && x.srcElement.dataset && x.srcElement.dataset.measurement_id)
				{
					if( mark_measurement_input_validity( x.srcElement ) == false )
					{
						return;
					}
					const measurement = Measurement.get( x.srcElement.dataset.measurement_id )
					if( measurement instanceof Measurement )
					{
						measurement.html.value.value = tools_number_format_localized( measurement.converted_value )
					}
				}
			}

			function html_event_measurement_unit_change(x)
			{
				develope.message( "measurement_unit" , x.srcElement )
				if(x.srcElement.value && x.srcElement.dataset && x.srcElement.dataset.measurement_id)
				{
					const value = x.srcElement.value
					const measurement = Measurement.get( x.srcElement.dataset.measurement_id )
					if( measurement instanceof Measurement )
					{
						develope.message( "measurement_unit" , measurement )
						measurement.change_unit( value )
						measurement.html.value.value = tools_number_format_localized( measurement.converted_value )
						measurement.html.unit.innerHTML = afc_strings.units.short[measurement.selected_unit]
					}
				}
			}

			function html_event_pick_answer(x)
			{
				const answer_id = x.srcElement.dataset.answer_id
				const answer = Answer.get( answer_id )
				if( answer instanceof Answer  &&  answer.question instanceof Question )
				{
					const question = answer.question;

					if( question.type === Question.Types.radio )
					{
						const old_answer = question.get_given_answer()
						if( old_answer != answer )
						{
							if( question.give_answer( answer ) > 1 )
							{
								answer.html.button.value = "selected"
								if( old_answer != null )
								{
									old_answer.html.button.value = ""
									develope.message( old_answer , "=>" , answer.id )
								}
							}
						}

						html_navbar.answer().callback()
					}
					else
					if( question.type === Question.Types.checkbox )
					{
						const change = question.give_answer( answer )
						if( change < 0 )
						{
							develope.message( answer.id ,  "out" , question._given_answer_ids )
							answer.html.button.value = ""
							answer.html.button.innerHTML = afc_strings.select
							answer.html.button.title = afc_strings.select
						}
						else
						if( change > 0 )
						{
							develope.message( answer.id ,  "in" , question._given_answer_ids )
							answer.html.button.value = "selected"
							answer.html.button.innerHTML = afc_strings.unselect
							answer.html.button.title = afc_strings.unselect
						}
						else 
						{
							develope.message( answer.id ,  change , question._given_answer_ids ) 
						}
					}

					console.debug( "code: " + Save_Slot.get_current_code(boat) )
					Save_Slot.write_to_local_stroage( Save_Slot.get_current_code(boat) )
				}
			}

			function html_event_alternative_product(x)
			{
				const e = x.srcElement

				if( e.value )
				{
					const i0 = Number.parseInt( e.value )
					develope.message( "alternative_product: i0: " , i0 )
					if( !isNaN(i0) && (i0 >= 0) 
						&& (i0 < recipe.recipe_categories.length) )
					{
						// recipe._category_selected_index0 = i0;
						recipe.select_category( i0 + 1 );
						recipe.set_boat_recipe_products();
						update_recipe_html();
					}
				}
			}

			function html_event_colour_select(x)
			{
				// debugger

				const e = x.srcElement

				if( (e.dataset) && (e.dataset.colour) && (e.dataset.kind) )
				{
					const colour_id = e.dataset.colour
					const kind_id = e.dataset.kind

					const colour = Colour.get_Colour_by_id( colour_id )

					if( Colour.is_Colour(colour) )
					{
						var colour_has_changed = false;

						const category = recipe.selected_category

						if( category instanceof Recipe_Category )
						{
							const recipe_products = category.get_recipe_products_by_kind_id(kind_id)
							for( const recipe_product of recipe_products )
							{
								const rp = recipe_product
								if( rp instanceof Recipe_Product )
								{
									const changed = rp.set_to_Colour( colour )
									if( changed > 0 )
									{
										colour_has_changed = true
										// update_colour_display( e , colour , kind_id )
									}
								}
							}
						}

						if( colour_has_changed === true )
						{
							// calculator.calculate( colour )
							calculator.calculate( colour )
							develope.message("Colour changed", { category, colour, kind_id } )
							update_recipe_html();
						}
					}
				}
			}

			// function html_event_order_product_button(x)
			// {
			// 	const e = x.srcElement

			// 	cart_add_product()
			// }

			// function html_event_order_primer_button(x)
			// {
			// 	const e = x.srcElement

			// 	cart_add_primer()
			// }

			// function html_event_order_both_button(x)
			// {
			// 	const e = x.srcElement

			// 	cart_add_product()
			// 	cart_add_primer()
			// }

			function html_event_order_all_button(x)
			{
				const e = x.srcElement

				cart_add_recipe_products();
			}


			function cart_add_recipe_products()
			{
				const category = recipe.selected_category
				const kind_ids = ["Antifouling","Primer","Tie_Coat"]

				if( (category instanceof Recipe_Category)
					&& (category.is_included()) )
				{
					const code = Save_Slot.get_current_code( boat );

					const variant_ids = []
					const order_counts = []

					console.debug("recipe:")

					for( const kind_id of kind_ids )
					{
						const recipe_products
							= category.get_recipe_products_by_kind_id(kind_id)
						for( const rp of recipe_products )
						{
							if( (rp instanceof Recipe_Product)
								&& (rp.is_not_excluded)
								&& (rp._variants.length > 0)
								&& (rp._variants.length === rp._variant_counts.length) )
							{
								const variants = rp._variants
								const counts   = rp._variant_counts

								for( var i0variant = 0 ;  i0variant < variants.length ;  i0variant += 1 )
								{
									const variant = variants[i0variant]
									const count = counts[i0variant]
									console.debug(
										count + "x " + variant.product.label
										+ " (" + variant.id + ")"
									)

									if( (variant instanceof Product_Variant)
										&& (count > 0) )
									{
										variant_ids.push( variant.variant_id )
										order_counts.push( count )
									}
								}
							}
						}
					}

					if( variant_ids.length > 0
						&& order_counts.length === variant_ids.length )
					{
						console.debug("adding to cart ...")

						const ordered = Shopify_Tools.put_into_cart
						(
							variant_ids ,
							order_counts ,
							{
								"_Configurator": Save_Slot.get_current_code(boat)
							}
						)

						function wait_for_json( object_with_json , delay_ms = 250 , max_delay = 5000 )
						{
							if( max_delay < 0 )
							{
								return -1;
							}

							const json = object_with_json.json
							if( null == json  )
							{
								console.debug( "waiting ... " + (max_delay - delay_ms) + "ms" );
								window.setTimeout(
									() => {
										wait_for_json(
											object_with_json ,
											delay_ms ,
											(max_delay - delay_ms)
										);
									},
									delay_ms
								)
								return - 1 - max_delay;
							}

							if( typeof(json) == "object"
								&& "items" in json
							) {
								var length = 0
								const items = json.items

								if( Array.isArray(items) )
								{
									length = items.length;
								}

								console.debug( "... added to cart: " + length );

								if( length > 0 )
								{
									Shopify_Tools.theme_concept_update_cart_event( false , 100 )
									Shopify_Tools.theme_concept_update_cart_event( true , 100 )
								}

								return length;
							}
						}

						wait_for_json( ordered )
					}
				}
			}


			// function cart_add_product()
			// {
			// 	const category = recipe.selected_category

			// 	if( category == null ) { return false; }

			// 	const product  = recipe.product_selected
			// 	const product_amount = category.product_amount

			// 	const colour    = category.Colour
			// 	const amount_ml = category.product_amount_ml

			// 	const product_variant_index0 = pick_variant_index0( product , colour , amount_ml )

			// 	if( product_variant_index0 >= 0 )
			// 	{
			// 		Shopify_Tools.put_into_cart(
			// 				product.data.shopify.variants[product_variant_index0].id
			// 			, product_amount
			// 			, { "Configurator": Save_Slot.get_current_code(boat) } )
			// 	}

			// 	return true;
			// }


			// function cart_add_primer()
			// {
			// 	const category = recipe.selected_category

			// 	if( category == null ) { return false; }

			// 	for( var i0P = 0 ;  i0P < category.other_product_ids.length ;  i0P++ )
			// 	{
			// 		const PID = category.other_product_ids[i0P]

			// 		const primer = Product.get( PID )

			// 		if( primer instanceof Product )
			// 		{
			// 			if( primer.kind_id == "Primer" )
			// 			{
			// 				if( (category.other_product_amounts.length > i0P)
			// 					&& (category.other_product_amounts_product.length > i0P)
			// 				){
			// 					const primer_amount = 1
			// 					const amount_ml = category.other_product_amounts_product[i0P]
			// 					var colour = category.Colour
			// 					if( primer.colours.indexOf( colour ) < 0 )
			// 					{
			// 						colour = ""
			// 					}
			// 					const primer_variant_index0 = pick_variant_index0( primer , colour , amount_ml )

			// 					if( primer_variant_index0 >= 0 )
			// 					{
			// 						Shopify_Tools.put_into_cart(
			// 								primer.data.shopify.variants[primer_variant_index0].id
			// 							, primer_amount
			// 							, { "Configurator": Save_Slot.get_current_code(boat) } )
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}

			// 	return true;
			// }


			function html_event_start_begin_button(x)
			{
				html_navbar.page(1).callback();
			}

			function html_event_start_resume_button(x)
			{
				Save_Slot.load_dev_string( boat );
				update_selected_answers( boat );

				html_navbar.page(1).callback();
			}

			function html_hide_element(x){if(x instanceof HTMLElement){x.classList.add("display_none")   }}
			function html_show_element(x){if(x instanceof HTMLElement){x.classList.remove("display_none")}}

			// /**
			//  * @param {!Product} product
			//  * @param {!string} colour
			//  * @param {!number} amount_ml
			//  * @returns {number} */
			// function pick_variant_index0( product , colour , amount_ml )
			// {
			// 	for( var i0V = 0 ;  i0V < product.data.shopify.variants.length  ; i0V++ )
			// 	{
			// 		const variant = product.data.shopify.variants[i0V]
			// 		if( variant.amount_ml === amount_ml )
			// 		{
			// 			if( colour in afc_colours )
			// 			{
			// 				if( variant.colour == colour )
			// 				{
			// 					return i0V;
			// 				}
			// 			}
			// 			else
			// 			{
			// 				return i0V;
			// 			}
			// 		}
			// 	}

			// 	return -1;
			// }

			function update_colour_display( colour_id )
			{
				if( colour_id in afc_colours )
				{
					console.debug( colour_id )
					const selected = recipe.html.product.colours.selected.colour
					const text = recipe.html.product.colours.selected.text
					if( (selected instanceof HTMLElement)
						&&   ( text instanceof HTMLElement) )
					{
						selected.dataset.colour = colour_id
						text.innerHTML = afc_colours[colour_id].label
						text.title = afc_colours[colour_id].label
					}
				}
			}

			function update_selected_answers()
			{
				for( var i0A = 0; i0A < Answer.all_in_order.length; i0A++ )
				{
					/** @type {Answer} */
					const a = Answer.all_in_order[i0A]
					if( a.given === true )
					{
						html_navbar.pages_by_number[a.data.page].reachable = true
						html_navbar.pages_by_number[a.data.page].answered = true
						if( a.html.button )
						{
							a.html.button.value = "selected"
							if( a.type === Answer.Types.checkbox )
							{
								a.html.button.innerHTML = afc_strings.unselect
								a.html.button.title = afc_strings.unselect
							}
							else
							if( a.type === Answer.Types.radio )
							{
								a.html.button.innerHTML = afc_strings.select
								a.html.button.title = afc_strings.select
							}
						}
					}
					else
					if( a.given === false )
					{
						if( a.html.button )
						{
							a.html.button.value = ""
							if( a.type === Answer.Types.checkbox )
							{
								a.html.button.innerHTML = afc_strings.select
								a.html.button.title = afc_strings.select
							}
							else
							if( a.type === Answer.Types.radio )
							{
								a.html.button.innerHTML = afc_strings.select
								a.html.button.title = afc_strings.select
							}
						}
					}

					if( a.has_selection === true )
					{
						a.html.selection[a.selection.selected_index1 - 1].selected = true
					}

					if( a.type === Answer.Types.checkbox )
					{
						html_navbar.pages_by_number[a.data.page].reachable = true
						html_navbar.pages_by_number[a.data.page].answered = true
					}

					if( a.type === Answer.Types.measurement_unit )
					{
						const m = a.measurement
						if( m.html.value ) { m.html.value.value = m.converted_value }
						if( m.html.unit  ) { m.html.unit.innerHTML  = m.selected_unit }
						if( m.html.unit_selector ) { m.html.unit_selector.value = m.selected_unit }
						if( a.data.boat_value )
						{
							switch( a.data.boat_value )
							{
								case "width":
								case "length":
								case "depth":
								{
									html_navbar.pages_by_number[a.data.page].reachable = true
									html_navbar.pages_by_number[a.data.page].answered = true
									// m.html.value.innerHTML = m.converted_value
									// m.html.unit.innerHTML  = m.selected_unit
									// m.html.unit_selector.value = m.selected_unit
								}  break;
								case "factor" :  break;
							}
						}
					}
				}
				html_navbar.update_html();
			}

			function update_recipe_html()
			{
				const h = recipe.html

				const categories_in_display_order =
					[ recipe.recipe_categories[0]
					, recipe.recipe_categories[1]
					, recipe.recipe_categories[2]
					, recipe.recipe_categories[3]
				]

				var selected_category_index = recipe._category_selected_index0;

				var number_of_products = 0;

				if( selected_category_index >= 0 && selected_category_index < categories_in_display_order.length )
				{
					if( categories_in_display_order[selected_category_index].value <= 0 )
					{
						selected_category_index = -1;
					}
				}

				for( var iC = 0 ;  iC < categories_in_display_order.length ;  iC++ )
				{
					const category = categories_in_display_order[iC]
					if( category.get_main_recipe_product() instanceof Recipe_Product )
					{
						const product = category.get_main_recipe_product().get_product()

						if( product instanceof Product )
						{
							number_of_products++;
							if( selected_category_index < 0 )
							{
								selected_category_index = iC
							}
						}
					}
				}

				const product =
					(recipe.selected_category == null)
					|| (recipe.selected_category.get_main_recipe_product() == null)
					? null
					: recipe.selected_category.get_main_recipe_product().get_product()

				if( product == null ) //savety
				{
					number_of_products = 0
				}

				if( number_of_products <= 0 )
				{
					html_hide_element( h.product.image )
					html_hide_element( h.colours2.container )
					html_hide_element( h.product.usps.container )
					html_hide_element( h.alternatives.container )
					html_hide_element( h.steps.container )
				}
				else // if( number_of_products > 0 )
				{
					html_show_element( h.product.image )
					html_show_element( h.product.usps.container )
					html_show_element( h.alternatives.container )
					html_show_element( h.steps.container )
				}

				if( (number_of_products <= 0) || (selected_category_index < 0) )
				{
					h.recommendation.label.innerHTML = recipe_string( afc_strings.recipe.recommendation.no_product_label )
					h.product.label.innerHTML = recipe_string( afc_strings.recipe.no_product.label )
					h.product.text.innerHTML  = recipe_string( afc_strings.recipe.no_product.text  )
				}
				else
				if( (number_of_products > 0) && (selected_category_index >= 0) )
				{
					const category = categories_in_display_order[selected_category_index]

					h.recommendation.label.innerHTML = recipe_string( afc_strings.recipe.recommendation.label )
					h.product.label.innerHTML = recipe_string( afc_strings.recipe.product.label )
					h.product.text.innerHTML = recipe_string( afc_strings.recipe.product.text )
					html_hide_element( h.product.image )

					for( const image_url of product.image_urls )
					{
						if( typeof(image_url) === "string"
							&& image_url.length > 0 )
						{
							html_show_element( h.product.image )
							h.product.image.src = image_url
						}
					}

					update_USPs()
					function update_USPs()
					{
						html_hide_element( h.product.usps.container )
						h.product.usps.label.innerHTML = recipe_string( afc_strings.recipe.product.unique_selling_points.label )
						h.product.usps.text.innerHTML = ""
						h.product.usps.list.innerHTML = ""
						if( product.data.shopify && product.data.shopify.usps )
						{
							for( const usp of product.data.shopify.usps )
							{
								if( typeof(usp) === "string"
									&& usp.length > 0 )
								{
									h.product.usps.text.innerHTML = usp

									const li = document.createElement("LI")
									li.innerHTML = usp
									h.product.usps.list.appendChild( li )

									html_show_element( h.product.usps.container )
								}
							}
						}
					}

					update_colour_selection();
					// update_colour_display(current_colour_id);
					function update_colour_selection()
					{
						html_hide_element(	recipe.html.colours2.container )

						const h = recipe.html.colours2.list
						html_remove_children( h , "*" )

						const kind_ids = ["Antifouling","Primer","Tie_Coat"]

						if( category.is_included() )
						{
							for( const kind_id of kind_ids )
							{
								const recipe_products = category.get_recipe_products_by_kind_id(kind_id)

								for( const recipe_product of recipe_products )
								{
									if( recipe_product instanceof Recipe_Product )
									{
										if( recipe_product.has_Colour )
										{
											html_show_element(	recipe.html.colours2.container )

											const product = recipe_product.get_product()
											if( product instanceof Product )
											{
												const c = html_create_element( h , "DIV" )
												const label = html_create_element( c , "DIV" , "colour product_label" );
												label.innerHTML = recipe_product.get_product().label

												const selected = html_create_element( c , "DIV" , "colour colour_selected"        );
												const s_colour = html_create_element( selected , "DIV" , "colour colour_selected_colour" );

												s_colour.dataset.colour = recipe_product.selected_Colour.id
												s_colour.textContent = format_colour_label( recipe_product.selected_Colour )

												const colours = product.get_Colours();
												const list  = html_create_element( c , "DIV"  , "list"  );

												for( const colour of colours )
												{
													const li = html_create_element( list , "BUTTON" , "colour")
													li.textContent = format_colour_label( colour )
													li.title = format_colour_label( colour )
													li.dataset.colour = colour.id
													li.dataset.kind = product.kind_id
												}
											}
										}
									}
								}
							}
						}
					}
					//#endregion


					if( number_of_products <= 1 )
					{
						html_hide_element( recipe.html.alternatives.container )
					}
					if( number_of_products > 1 )
					{
						html_show_element( recipe.html.alternatives.container )

						for( var i0ac = 0 ;  i0ac < categories_in_display_order.length ;  i0ac++ )
						{
							const alternative_category = categories_in_display_order[i0ac]
							const ac = alternative_category
							const alternative_h = recipe.html.alternatives[ac.product_category_id]

							html_hide_element( alternative_h.container )

							if( (i0ac != selected_category_index)
								&& (ac.get_main_recipe_product() instanceof Recipe_Product) )
							{
								if( ac.product_category_id in recipe.html.alternatives )
								{
									const alternative_product = ac.get_main_recipe_product().get_product()
									if( alternative_product instanceof Product )
									{
										html_show_element( alternative_h.container )

										alternative_h.text.value = ac.index0
										alternative_h.text.innerHTML = alternative_product.label
									}
								}
							}
						}
					}

					for( var iS = 0;  iS < Step.all_in_order.length ; iS++ )
					{
						/** @type {Step} */
						const step = Step.all_in_order[iS]
						if( step instanceof Step )
						{
							step.deactivate()
							if( step.html.content	&& step.html.container )
							{
								html_remove_children( step.html.content , "*" )
								html_hide_element( step.html.container )
							}
						}
					}

					for( var iS = 0;  iS < category._steps.length ; iS++ )
					{
						/** @type {Step} */
						const step = category._steps[iS]

						if( (step != null)  && ("active" in step)
							&& ("html" in step)
							&& (step.html.container != null)
							&& (step.html.content != null) )
						{
							step.deactivate()
							for( const instruction_id of step.instruction_ids )
							{
								const instruction = Instruction.get( instruction_id )
								if( instruction == null )
								{
									develope.error( "Missing instruction" , instruction_id , step )
								}
								if( instruction instanceof Instruction )
								{
									if( instruction.text_ids.length == 0 )
									{
										develope.error( "Instruction has no text" , instruction )
									}
									for( const text_id of instruction.text_ids )
									{
										if( text_id in afc_strings.instructions )
										{
											const text = afc_strings.instructions[text_id]
											step.activate()
											html_create_element( step.html.content , "p" , "instruction" , "" , text )
										}
										else
										{
											develope.error( "Missing text" , text_id , instruction )
										}
									}
								}
							}

							if( step.active === true )
							{
								html_show_element( step.html.container )
							}
							else
							{
								html_hide_element( step.html.container )
							}
						}
					}

					// recipe.html.order.label.innerHTML  = recipe_string( afc_strings.recipe.order.label  )
					// recipe.html.order.text.innerHTML   = recipe_string( afc_strings.recipe.order.text   )
					// recipe.html.order.button.innerHTML = recipe_string( afc_strings.recipe.order.button )

					// recipe.html.order.primer.text.innerHTML   = recipe_string( afc_strings.recipe.order.primer.text   )
					// recipe.html.order.primer.button.innerHTML = recipe_string( afc_strings.recipe.order.primer.button )

					// recipe.html.order.both.text.innerHTML   = recipe_string( afc_strings.recipe.order.both.text   )
					// recipe.html.order.both.button.innerHTML = recipe_string( afc_strings.recipe.order.both.button )

					if( Shopify_Tools.theme_is( Shopify_Tools.Themes.concept ) )
					{
						html_show_element( recipe_html.order.container )
						order_tables()
					}
					else
					{
						html_hide_element( recipe_html.order.container )
					}
				}


				function order_tables()
				{
					const area = recipe.html.order.table_area

					if( area instanceof HTMLElement )
					{
						html_remove_children( area , "*" )

						const recipe_products = [
							recipe.get_selected_product_by_kind("Antifouling"),
							recipe.get_selected_product_by_kind("Primer"),
							recipe.get_selected_product_by_kind("Tie_Coat"),
						];

						var count_display = 0;

						for( const rp of recipe_products  )
						{
							if( rp instanceof Recipe_Product )
							{
								if( rp.has_variants_picked() )
								{
									++count_display;
								}
							}
						}

						const explanation = recipe.html.order.explanation
						if( explanation instanceof HTMLElement )
						{
							if( count_display > 0 )
							{
								explanation.innerHTML = order_explanation_html( recipe_products )
								html_show_element( explanation )
							}
							else
							{
								explanation.innerHTML = ""
								html_hide_element( explanation )
							}
						}

						if( count_display > 0 )
						{
							const table = html_create_element( area , "TABLE" )
							if( table instanceof HTMLTableElement )
							{
								table.innerHTML =
								`<colgroup>
									<col class="order_col_1">
									<col class="order_col_2">
									<col class="order_col_3">
								</colgroup>`

								for( const rp of recipe_products  )
								{
									if( rp instanceof Recipe_Product )
									{
										table_row( rp )
									}
								}

								if( Shopify_Tools.theme_is( Shopify_Tools.Themes.concept ) )
								{
									var button = html_create_element( area , "BUTTON" , "order_all" )
									if( button instanceof HTMLButtonElement )
									{
										button.innerHTML = afc_strings.recipe.order.button_all
										button.addEventListener( "click" , html_event_order_all_button )
									}
								}
							}

							function table_row( recipe_product )
							{
								if( (recipe_product instanceof Recipe_Product)
									&& ( recipe_product._variants.length > 0 )
									&& ( recipe_product._variants.length === recipe_product._variant_counts.length )
									&& (table instanceof HTMLTableElement)  )
								{
									for( var i0v = 0  ;  i0v < recipe_product._variants.length  ;  ++i0v )
									{
										const count = recipe_product._variant_counts[i0v]
										const variant = recipe_product._variants[i0v]

										console.debug( "dcw" , variant )

										var label = variant.label

										const amount_ml = variant.amount

										const amount_string = format_volume_from_ml( amount_ml )

										const amount_total_ml = count * amount_ml
										const amount_total_string = format_volume_from_ml( amount_total_ml )

										const colour = variant.Colour
										const colour_label = format_colour_label( colour )

										const price  = variant.price
										const price_total = count * price
										const currency_symbol  = ( typeof(variant.price_unit_string) === "string"
											&& variant.price_unit_string.length > 0 )
											? variant.price_unit_string
											: "€"
										
										const price_string
										= format_decimal( price / 100 , 2 , 2 ) + " " + currency_symbol
										
										const price_total_string 
										= format_decimal( price_total / 100 , 2 , 2 ) + " " + currency_symbol

										const product = recipe_product.get_product()
										if( product instanceof Product )
										{
											label = product.label
										}

										var row = table.insertRow()
										row.classList.add("order_empty")
										var cell = row.insertCell()
										cell.classList.add("order_empty")
										cell.colSpan = 3
										cell.textContent = " "

										var row = table.insertRow()

										var cell = row.insertCell()
										cell.colSpan = 3
										cell.classList.add("order_label")
										cell.textContent = label
										cell.title = label

										if( Colour.is_Colour(colour))
										{
											var row = table.insertRow()
	
											var cell = row.insertCell()
											cell.colSpan = 3
											cell.classList.add("order_colour")
											cell.textContent = "" + colour_label
										}


										var row = table.insertRow()

										var cell = row.insertCell()
										cell.rowSpan = 1
										cell.classList.add("order_count")
										cell.textContent = "" + count + "x"

										var cell = row.insertCell()
										cell.classList.add("order_amount")
										cell.textContent = "" + amount_string 

										var cell = row.insertCell()
										cell.classList.add("order_price")
										cell.textContent = "" + price_string

										var row = table.insertRow()
										row.classList.add("order_total")

										var cell = row.insertCell()
										cell.colSpan = 2
										cell.classList.add("order_amount")
										cell.textContent = afc_strings.recipe.order.total + " " + amount_total_string

										var cell = row.insertCell()
										cell.classList.add("order_price")
										cell.textContent = "" + price_total_string
									}
								}
							}
						}
					}
				}


				function order_explanation_html( recipe_products )
				{
					const lines = []
					for( const recipe_product of recipe_products )
					{
						if( recipe_product instanceof Recipe_Product
							&& recipe_product.has_variants_picked() )
						{
							lines.push( order_explanation_line_html( recipe_product ) )
						}
					}

					if( lines.length <= 0 )
					{
						return "";
					}

					if( is_english_language() )
					{
						return ""
							+ "<p>The quantities are calculated from the underwater area, the theoretical coverage stated in the product data sheet and the recommended number of coats. The calculated requirement is rounded up to available pack sizes. A rough or absorbent substrate and the application method can increase actual consumption.</p>"
							+ "<ul>" + lines.join("") + "</ul>";
					}

					return ""
						+ "<p>Die Mengen berechnen sich aus Ihrer Unterwasserfl&auml;che, der theoretischen Ergiebigkeit laut Produktdatenblatt und der empfohlenen Anzahl an Schichten. F&uuml;r den Warenkorb wird der rechnerische Bedarf auf die verf&uuml;gbaren Gebinde aufgerundet. Ein rauer oder saugender Untergrund sowie die Verarbeitung k&ouml;nnen den tats&auml;chlichen Verbrauch erh&ouml;hen.</p>"
						+ "<ul>" + lines.join("") + "</ul>";
				}

				function order_explanation_line_html( recipe_product )
				{
					const product = recipe_product.get_product()
					const label = ( product instanceof Product )
						? product.label
						: ""
					const area_m2 = get_boat_area_square_m()
					const coverage = recipe_product.get_coverage_sqm_per_l( 10.0 )
					const needed_text = format_volume_from_ml( recipe_product.needed_amount_total )
					const picked_text = format_volume_from_ml( recipe_product.calculated_amount_total )
					const package_text = format_recipe_product_packages( recipe_product )

					if( is_english_language() )
					{
						return ""
							+ "<li><strong>" + label + ":</strong> "
							+ format_layers_text( recipe_product.needed_multiplier )
							+ " on " + format_area_square_m( area_m2 ) + " m&sup2;"
							+ " at approx. " + format_decimal( coverage , 1 , 0 ) + " m&sup2;/L gives "
							+ needed_text + " calculated requirement. "
							+ "Cart: " + package_text + " = " + picked_text + ", so the quantity is sufficient."
							+ "</li>";
					}

					return ""
						+ "<li><strong>" + label + ":</strong> "
						+ format_layers_text( recipe_product.needed_multiplier )
						+ " auf " + format_area_square_m( area_m2 ) + " m&sup2;"
						+ " bei ca. " + format_decimal( coverage , 1 , 0 ) + " m&sup2;/L ergeben "
						+ needed_text + " rechnerischen Bedarf. "
						+ "Im Warenkorb: " + package_text + " = " + picked_text + "; damit ist der rechnerische Bedarf abgedeckt."
						+ "</li>";
				}

				function format_recipe_product_packages( recipe_product )
				{
					const parts = []
					if( recipe_product instanceof Recipe_Product
						&& recipe_product._variants.length === recipe_product._variant_counts.length )
					{
						for( var i0v = 0 ; i0v < recipe_product._variants.length ; ++i0v )
						{
							const variant = recipe_product._variants[i0v]
							const count = recipe_product._variant_counts[i0v]
							if( variant instanceof Product_Variant && count > 0 )
							{
								parts.push( count + " x " + format_volume_from_ml( variant.amount ) )
							}
						}
					}
					return parts.join( ", " )
				}

				function get_boat_area_square_m()
				{
					return boat.effective_area_in_square_cm / 10000.0
				}

				function format_decimal( value , maximum_fraction_digits = 2 , minimum_fraction_digits = 0 )
				{
					if( typeof(value) !== "number"
						|| Number.isFinite(value) === false )
					{
						return "0";
					}

					return new Intl.NumberFormat(
						is_english_language() ? "en-GB" : "de-DE" ,
						{
							minimumFractionDigits: minimum_fraction_digits,
							maximumFractionDigits: maximum_fraction_digits
						}
					).format( value );
				}

				function format_area_square_m( value )
				{
					return format_decimal( value , 1 , 0 )
				}

				function format_liters_from_ml( amount_ml )
				{
					return format_decimal( amount_ml / 1000.0 , 2 , 0 )
				}

				function format_milliliters( amount_ml )
				{
					return format_decimal( amount_ml , 0 , 0 )
				}

				function format_volume_from_ml( amount_ml )
				{
					if( typeof(amount_ml) !== "number"
						|| Number.isFinite(amount_ml) === false )
					{
						return "0 ml";
					}

					if( amount_ml >= 1000 )
					{
						return format_liters_from_ml( amount_ml ) + " L";
					}

					return format_milliliters( amount_ml ) + " ml";
				}

				function format_layers_text( layers )
				{
					const layer_count = Math.max( 0 , Math.round( layers ) )
					if( is_english_language() )
					{
						if( layer_count === 1 )
						{
							return "1 coat";
						}
						return layer_count + " coats";
					}

					if( layer_count === 1 )
					{
						return "1 Schicht";
					}
					return layer_count + " Schichten";
				}

				function format_colour_label( colour )
				{
					if( Colour.is_Colour(colour) === false )
					{
						return "";
					}

					const label = ( typeof(colour.label) === "string" )
						? colour.label.trim()
						: ""
					if( is_english_language() === false )
					{
						return label;
					}

					const key = ( String(colour.id || label) + " " + label )
						.toLowerCase()
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, "")
						.replace(/\u00df/g, "ss")
						.replace(/[^a-z0-9]+/g, " ")
						.trim()

					if( key.includes("silver") || key.includes("silber") )
					{
						return ( key.includes("gray") || key.includes("grey") || key.includes("grau") )
							? "Silver/grey"
							: "Silver";
					}
					if( key.includes("navy") )       { return "Navy blue"; }
					if( key.includes("dark blue") || key.includes("dunkelblau") ) { return "Dark blue"; }
					if( key.includes("middle blue") || key.includes("mittel blau") ) { return "Mid blue"; }
					if( key.includes("white") || key.includes("weiss") ) { return "White"; }
					if( key.includes("black") || key.includes("schwarz") ) { return "Black"; }
					if( key.includes("gray") || key.includes("grey") || key.includes("grau") ) { return "Grey"; }
					if( key.includes("red") || key.includes("rot") ) { return "Red"; }
					if( key.includes("blue") || key.includes("blau") ) { return "Blue"; }

					return label;
				}

				function is_english_language()
				{
					if( typeof(afc_strings.language) === "string" )
					{
						const language = afc_strings.language.toLowerCase()
						return language === "en" || language.indexOf("english") >= 0;
					}
					return false;
				}

				function recipe_string(string = "")
				{
					var result = ""

					const category = recipe.selected_category
					if( (category instanceof Recipe_Category)
						&& category.is_included()	)
					{
						const recipe_product = category.get_main_recipe_product()

						var antifouling = recipe.get_selected_product_by_kind("Antifouling")
						var primer      = recipe.get_selected_product_by_kind("Primer")
						var tiecoat     = recipe.get_selected_product_by_kind("Tie_Coat")

						const splits = string.split("]]")

						for( const split of splits )
						{
							const position = split.indexOf("[[")

							if( position > 0 )
							{
								result += split.substring( 0 , position )
							}

							if( position >= 0 )
							{
								var command = split.substring( position + 2 ).trim().toLowerCase()

								switch( command )
								{
									case "product":
									case "recommended":
									{
										result += antifouling.get_product().label.trim()
									} break;

									case "volume_ml":
									{
										result += format_milliliters( recipe_product.needed_amount_total )
									} break;

									case "volume_text":
									{
										result += format_volume_from_ml( recipe_product.needed_amount_total )
									} break;

									case "volume_l":
									case "volume":
									{
										result += format_liters_from_ml( recipe_product.needed_amount_total )
									} break;

									case "layers":
									{
										result += recipe_product.needed_multiplier
									} break;

									case "layers_text":
									{
										result += format_layers_text( recipe_product.needed_multiplier )
									} break;

									case "amount":
									{
										result += recipe_product._variant_counts[0]
									} break;

									case "amount_l":
									{
										result += format_liters_from_ml( recipe_product.calculated_amount_total )
									} break;
									case "amount_ml":
									{
										result += format_milliliters( recipe_product.calculated_amount_total )
									} break;
									case "amount_text":
									{
										result += format_volume_from_ml( recipe_product.calculated_amount_total )
									} break;

									// case "amount_l_total":
									// {
									// 	result += category.product_amount_ml_total / 1000.0
									// } break;
									// case "amount_ml_total":
									// {
									// 	result += category.product_amount_ml_total
									// } break;

									case "area_m":
									{
										result += format_area_square_m( get_boat_area_square_m() )
									} break;
									case "area_cm":
									{
										result += format_decimal( boat.effective_area_in_square_cm , 0 , 0 )
									} break;

									case "primer_volume_ml":
									case "primer_volume_l":
									case "primer_volume":
									case "primer_volume_text":
									case "primer_amount_ml":
									case "primer_amount_l":
									case "primer_amount":
									case "primer_amount_text":
									case "primer_layers":
									case "primer_layers_text":
									case "primer":
									{
										if( primer instanceof Recipe_Product )
										{
											switch( command )
											{
												case "primer":
												{
													result += primer.get_product().label
												} break;
												case "primer_volume_l":
												case "primer_volume":
												{
													result += format_liters_from_ml( primer.needed_amount_total )
												} break;
												case "primer_volume_ml":
												{
													result += format_milliliters( primer.needed_amount_total )
												} break;
												case "primer_volume_text":
												{
													result += format_volume_from_ml( primer.needed_amount_total )
												} break;
												case "primer_amount_l":
												case "primer_amount":
												{
													result += format_liters_from_ml( primer.calculated_amount_total )
												} break;
												case "primer_amount_ml":
												{
													result += format_milliliters( primer.calculated_amount_total )
												} break;
												case "primer_amount_text":
												{
													result += format_volume_from_ml( primer.calculated_amount_total )
												} break;
												case "primer_layers":
												{
													result += primer.needed_multiplier
												} break;
												case "primer_layers_text":
												{
													result += format_layers_text( primer.needed_multiplier )
												} break;
											}
										}
									} break;
								}
							}

							if( position < 0 )
							{
								result += split
							}
						}

						return result;
					}

					return string;
				}
			}


			function update_navbar()
			{
			}

			function navigation_callback( page , options = null )
			{
				develope.message( "navigation_callback: " , page )

				var show_element = null

				if( page.id == "S" )
				{
					var show_element = html_startup_container
				}
				else
				if( page.id == "R" )
				{
					var show_element = html_recipe_container
				}
				else
				{
					const q = Question.get( "q" + (page.number) );
					if( q && (q.html) && (q.html.container) )
					{
						var show_element = q.html.container
					}
				}

				if( show_element != null )
				{
					if( html_current_element_to_be_shown != null )
					{
						html_hide_element( html_current_element_to_be_shown )
					}
					html_current_element_to_be_shown = show_element
					html_show_element( html_current_element_to_be_shown )
					// show_element.scrollIntoView({behaviour:"smooth",block:"center"});
					html_afc_container.scrollIntoView();
				}
			}
		}
	}

	console.debug("\r\n... CIAU")

	function imports()
	{
		const ids =
			["dfxpnwhebwvtppxfcqnvtfazbndvhhnf" /* tools         */
			,"pctkxnbaevzdafnwnccdqdnqbxztptke" /* shopify_tools */
			,"nnhnwqxqwxevbcwezdczwctxqkhqtnxh" /* navbar        */

			,"xxzpawvbpvwnwawbnazvkkpqvbhwadva" /* strings       */
			,"tvfpxpczkhfkhevnktpqfdqtwacpabct" /* instruction_strings */
			,"qfnatpdpnvkwzatnbhvbxcbvxhndnpvx" /* products      */
			,"wdtazcakwcbfttehntqqbpqpqnwqkbdb" /* values        */
			,"xtcdpncdnvhaeafveqkdfkevtndwnwat" /* instructions        */
			,"xnkdwqtcebqffddkqccqwabwbdhkpxec" /* rules               */
		]

		for( const id of ids )
		{
			if( (id in window) === false )
			{
				console.debug("Missing import ... ILL BE BACK ..." , id , window)
				if( import_timeout < 0 ) { import_timeout = 0; }
				import_timeout += 50
				if( import_timeout > 1000 ) { return false; } // give up
				setTimeout( anti_fouling_configurator_enclosure_eqcandxxbakvhkpebvdcqkcfkndfdwfa , import_timeout )
				return false;
			}
		}

		return true;
	}
}


function Pages_Navigation(amount, current, callback_function)
{
	"use strict";

	if (amount < 0 || amount > 10) { amount = 0 }
	if (current < 1) { current = 1 }
	if (current > amount) { current = amount }

	// page navigation object
	const pno = {
		current_index0: 0
		, amount: 10
		, callback_function: callback_function
		, callback_object: null
		, pages: [
			{  index0: 0 , id: "1" , number: 1 , label: "1" , text: "1. Frage" , reachable:true  , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 1 , id: "2" , number: 2 , label: "2" , text: "2. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 2 , id: "3" , number: 3 , label: "3" , text: "3. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 3 , id: "4" , number: 4 , label: "4" , text: "4. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 4 , id: "5" , number: 5 , label: "5" , text: "5. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 5 , id: "6" , number: 6 , label: "6" , text: "6. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ index0: 6 , id: "7" , number: 7 , label: "7" , text: "7. Frage" , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
			,{ hidden: true ,
			   index0: 7 , id: "R" , number: 8 , label: "R" , text: "Rezept"   , reachable:false , answered:false , html:{ buttons:[] , connectors:[] } , data:{} }
		]
		, start_page : {  index0: 8 , id: "S" , number: 0 , label: "S" , text: "Start"    , reachable:true  , answered:true  , html:{ buttons:[] , connectors:[] } , data:{} }
		, pages_by_number: {}
		, pages_by_id: {}
		, nav_elements: []
		, handleEvent(a)
		{
			const number = 0 + Number.parseInt(a.srcElement.name)
			if( number >= 0 && number <= this.amount  && this.pages[number] )
			{
				const page = this.pages[number]
				if( page.reachable )
				{
					this.current_index0 = number
					this.update_html()
					if( typeof this.callback_function === "function" )
					{
						this.callback_function( this.pages[this.current_index0] )
					}
				}
			}
		}
		, create_html( parent = null )
		{
			const nav_element = document.createElement("nav")
			nav_element.classList.add("pages")
			for( var i = 0; i < this.pages.length; i += 1)
			{
				const page = this.pages[i]

				const button = document.createElement("button")
				page.html.buttons.push(button)

				if (i > 0)
				{
					const connector = document.createElement("div")
					connector.classList.add("connector")
					connector.classList.add("disconnected")
					page.html.connectors.push(connector)
					nav_element.appendChild(connector)
				}
				else
				{
					page.html.connectors.push(null)
				}

				button.name = i
				button.innerHTML = page.label
				button.title = page.text
				button.classList.add("page")

				button.value = "q"
				button.disabled = true

				nav_element.appendChild(button)
			}
			nav_element.addEventListener("click", this)

			this.nav_elements.push(nav_element)

			this.update_html()

			if( parent instanceof HTMLElement )
			{
				parent.appendChild( nav_element )
			}

			return nav_element;
		}
		, update_html()
		{
			for( var j = 0;  j < this.nav_elements.length ;  j+= 1 )
			{
				for( var i = 0;  i < this.pages.length;  i += 1 )
				{
					const page = this.pages[i]
					const previous = (i < 1) ? (null) : (this.pages[i - 1])

					const button = page.html.buttons[j]

					if( page.index0 === this.current_index0 )
					{
						button.value = "c"
					}
					else
					{
						if( page.answered === true)
						{
							button.value = "a"
						}
						else
						{
							button.value = "q"
						}
					}

					if( page.reachable === true )
					{
						button.disabled = false
					}
					else
					{
						button.disabled = true
					}

					if( page.hidden )
					{
						button.hidden = true;
					}
					else
					{
						button.hidden = false;
					}

					if( previous != null )
					{
						if( previous.reachable === true && page.reachable === true )
						{
							page.html.connectors[j].classList.add("connected")
							page.html.connectors[j].classList.remove("disconnected")
						}
						else
						{
							page.html.connectors[j].classList.remove("connected")
							page.html.connectors[j].classList.add("disconnected")
						}
					}
				}
			}
		}
		, page( page_number )
		{
			if( page_number in this.pages_by_number )
			{
				const page = this.pages_by_number[page_number]

				if( page.reachable === true )
				{
					this.current_index0 = page.index0
				}

				this.update_html()
			}
			return this;
		}
		, page_next()
		{
			return this.page(this.pages[this.current_index0].number + 1)
		}
		, page_previous()
		{
			return this.page(this.pages[this.current_index0].number - 1)
		}
		, answer( answered = true )
		{
			const page = this.pages[this.current_index0]

			page.answered = answered

			if( (this.amount - 1) > page.index0 )
			{
				const next_page = this.pages[this.current_index0 + 1]
				next_page.reachable = true
				return this.page_next();
			}

			return this;
		}
		, callback()
		{
			if( typeof(this.callback_function) === "function" )
			{
				this.callback_function( this.pages[this.current_index0] )
			}
		}
	}

	for( const page of pno.pages )
	{
		pno.pages_by_number[page.number] = page
		pno.pages_by_id[page.id] = page
	}

	if( typeof pno.callback_function === "function" )
	{
		// pno.callback_function( pno.pages[pno.current] )
	}

	return pno;
}
